import React, { useState, useEffect } from 'react';
import { getNamesOfDays } from '../calendarHelper.js';

import DayOfWeekName from './DayOfWeekName.jsx';

const CreateDaysHeader = () => {
    const [daysOfWeek, setDaysOfWeek] = useState([]);
    // const daysOfWeek = getNamesOfDays('long', 'ja-JP');
    // const daysOfWeek = getNamesOfDays('long', 'zh-CN');
    // const daysOfWeek = getNamesOfDays('long', 'uk-UA');
    
    useEffect( () => {
        if(window.innerWidth < 992) {
            setDaysOfWeek(getNamesOfDays('short'))
        }
        if(window.innerWidth >= 992) {
            setDaysOfWeek(getNamesOfDays())
        }


        const handleResize = () => {
            if(window.innerWidth < 992) {
                setDaysOfWeek(getNamesOfDays('short'))
            }
            if(window.innerWidth >= 992) {
                setDaysOfWeek(getNamesOfDays())
            }
        };
        
        window.addEventListener('resize', handleResize);
    }, [])

    return(
        <div className="daysOfWeekHeader row">
            {
                daysOfWeek.map( (day, idx) => <DayOfWeekName day={day} key={`dayOfWeek-${idx}`} />)
            }
        </div>
    )
}

export default CreateDaysHeader;